import { debounce } from 'lodash';

import { Suggestion } from './types';

const debouncedFetch = debounce(async (apiCall, callback) => {
  try {
    const data = await apiCall();

    callback(data);
  } catch {
    callback([]);
  }
}, 250);

export const debouncedSuggestions = async (
  apiCall: () => Promise<Suggestion[] | null>
): Promise<Suggestion[]> => {
  return new Promise(resolve => {
    debouncedFetch(apiCall, results => {
      resolve(results);
    });
  });
};
